var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:(_vm.style)},[_c('path',{attrs:{"fill":_vm.fillColor,"d":"M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }